if (!customElements.get('cos-home-banner')) {
  customElements.define('cos-home-banner', class extends HTMLElement {
    connectedCallback() {
      this.onSelect = (event) => {
        const slides = Array.from(this.querySelectorAll('.swiper-slide'));
        const index = slides.findIndex((slide) => slide.contains(event.target));
        if (index < 0 || !this.slider) return;
        this.slider.slideTo(index, 0);
        this.slider.autoplay?.stop();
      };
      this.onDeselect = () => {
        if (this.dataset.autoplay === 'true') this.slider?.autoplay?.start();
      };
      this.addEventListener('shopify:block:select', this.onSelect);
      this.addEventListener('shopify:block:deselect', this.onDeselect);
      this.initialize = () => {
        if (this.slider || !this.isConnected || !window.Swiper) return;
        const multiple = this.querySelectorAll('.swiper-slide').length > 1;
        this.slider = new window.Swiper(this.querySelector('[data-banner-slider]'), {
          slidesPerView: 1,
          spaceBetween: 1,
          rewind: true,
          watchOverflow: true,
          autoplay: multiple && this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? { delay: Number(this.dataset.interval) || 3000, disableOnInteraction: false, pauseOnMouseEnter: true }
            : false
        });
      };
      this.initialize();
      window.addEventListener('load', this.initialize, { once: true });
    }
    disconnectedCallback() {
      window.removeEventListener('load', this.initialize);
      this.removeEventListener('shopify:block:select', this.onSelect);
      this.removeEventListener('shopify:block:deselect', this.onDeselect);
      this.slider?.destroy(true, true);
      this.slider = null;
    }
  });
}
